import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DateDay } from 'app/shared/constants/date-day.constant';
import { EmployeeType } from 'app/shared/constants/employee-type';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { Menus } from 'app/shared/constants/menu.constant';
import { Roles } from 'app/shared/constants/roles.constant';
import { Settings } from 'app/shared/constants/settingDate.constant';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { ExportDataService } from 'app/shared/service/export.service';
import { FilterDataService } from 'app/shared/service/filter-date.service';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { NavigateRightService } from 'app/shared/service/navigate-rights.service';
import { SharedService } from 'app/shared/service/shared.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import { weekdays } from 'moment';
import { ConfirmationService } from 'primeng/api';
import { CreateOrUpdateLeaveApplicationDto } from 'shared/service-proxies/models/create-or-update-leave-application-dto.model';
import { EmpNameWithCode } from 'shared/service-proxies/models/emp-name-with-code.model';
import { EmployeeSummaryDto } from 'shared/service-proxies/models/employee-summary-dto.model';
import { EnumValues } from 'shared/service-proxies/models/enum-values.model';
import { FilterAccessDTO } from 'shared/service-proxies/models/filter-dto-model';
import { LeaveApplicationDto } from 'shared/service-proxies/models/leave-application-dto.model';
import { LeaveBalanceDetailsDto } from 'shared/service-proxies/models/leave-balance-details-dto.model';
import { LeaveDtoApiResponse } from 'shared/service-proxies/models/leave-dto-api-response.model';
import { LeaveDto } from 'shared/service-proxies/models/leave-dto.model';
import { SettingListDto } from 'shared/service-proxies/models/setting-list-dto.model';
import { TransactionApplicationDto } from 'shared/service-proxies/models/transaction-application-dto.model';
import { UpdateTransactionStatusDto } from 'shared/service-proxies/models/update-transaction-status-dto.model';
import { CommonEnumValuesServiceProxy } from 'shared/service-proxies/services/common-enum-values.service';
import { EmployeeServiceProxy } from 'shared/service-proxies/services/employee.service';
import { LeaveApplicationServiceProxy } from 'shared/service-proxies/services/leave-application.service';
import { LeaveTypeServiceProxy } from 'shared/service-proxies/services/leave-type.service';
import { ReportServiceProxy } from 'shared/service-proxies/services/report.service';
import { SettingServiceProxy } from 'shared/service-proxies/services/setting.service';

@Component({
  selector: 'app-leave-application',
  templateUrl: './leave-application.component.html',
  styleUrls: ['./leave-application.component.scss']
})
export class LeaveApplicationComponent implements OnInit {
  @ViewChild('templateRefName') el: ElementRef;
  dateFormat = Settings.dateFormat;
  dateTimeformat = Settings.dateTimeformat;
  calendarDateFormat = Settings.calendarDateFormat;
  leaveApplications: LeaveApplicationDto[];
  leaveApplication: CreateOrUpdateLeaveApplicationDto;
  submitted: boolean;
  leaveApplicationDialog: boolean;
  employees: EmpNameWithCode[];
  employee: EmpNameWithCode = new EmpNameWithCode();
  approvers: EmpNameWithCode[];
  approversData: EmpNameWithCode[];
  leaveTypes: LeaveDto[];
  selectedEmployee: any;
  selectedApprover: any;
  selectedLeaveType: any;
  totalDay: any;
  selectedstatus: any = 0;
  status: EnumValues[] = [];
  rolewiseData: any;
  leaveSubmit: any;
  maximum: any;
  allOverTimeStatus: boolean;
  showButton: boolean;
  first: number = 0;
  allOverTimeArray: LeaveApplicationDto[];
  selectedValues: UpdateTransactionStatusDto = new UpdateTransactionStatusDto();
  selectedValue: Array<number> = [];
  data: Array<number> = [];
  isAdmin: any;
  role: any;
  leaveDataFilter?: TransactionApplicationDto = new TransactionApplicationDto();
  filter?: TransactionApplicationDto = new TransactionApplicationDto();
  filterDialog: boolean = false;
  accessFilter?: FilterAccessDTO = new FilterAccessDTO();
  date: Date = new Date();
  minimumTime: boolean;
  selectedTime: LeaveDto = new LeaveDto();
  isValidTime: boolean;
  time: any;
  leavetype: any;
  fromTime: any;
  toTime: any;
  shiftInTime: any;
  shiftOutTime: any;
  leavetypename: any;
  isShortorHalfLeave: boolean = false;
  menuAccess: any;
  isLeaveDisabled: boolean = false;
  exportList: LeaveApplicationDto[];
  remarkMaxLength: number;
  currentUser: any;
  editDisable: boolean = true;
  total: number = 0;
  ActiveType: any = []
  day = DateDay;
  true: boolean = true
  leaveBalance: LeaveBalanceDetailsDto[];
  isShowBalance: boolean = false;
  leaveBalanceReport: LeaveBalanceDetailsDto[];
  leaveBalanceDetails: EmployeeSummaryDto[];
  balance: any = 0;
  _obj: TransactionApplicationDto = new TransactionApplicationDto();
  selectedType: boolean = false;
  isBalanceExists: boolean = false;
  dayDiff = 0;
  isUser: boolean;
  employeeId: any;
  LockApprover : boolean = false;
  ApproverDisable:boolean

  originalDiffDay: number = 0;
  constructor(private _leaveApplicationServiceProxy: LeaveApplicationServiceProxy,
    private _employeeServiceProxy: EmployeeServiceProxy,
    private _leaveTypeServiceProxy: LeaveTypeServiceProxy,
    private confirmationService: ConfirmationService,
    private _transactionSeriviceProxy: CommonEnumValuesServiceProxy,
    private _toasterService: ToasterService,
    private _navigateRightsService: NavigateRightService,
    private datepipe: DatePipe,
    private filterDataService: FilterDataService,
    private sharedService: SharedService,
    private _authenticationService: AuthenticationService,
    private changeDetector: ChangeDetectorRef,
    private _exportDataService: ExportDataService,
    private _localStorage: LocalStorageService,
    private _reportService: ReportServiceProxy,
    private settingService: SettingServiceProxy
  ) {
   }

  ngOnInit(): void {
    this.getMenuAccess();
    this.isAdmin = this._authenticationService.isAdministrator();
    this.currentUser = this._localStorage.getData(LocalStorage.CURRENT_USER);
    this.getSettings();
    this.getApprover();
    this.getEmployee();
    this.getLeaveType();
    this.getStatus();
    this.showdata();
    this.getleaveabalance();
    setTimeout(() => {
      this.dateFilter();
      if (this.sharedService.referenceNo != 0) this.getLeaveApplication();
      else this.submitDialogs(this.leaveDataFilter);
    });

    this.sharedService.redirect.subscribe(redirectTo => {
      if (this.sharedService.referenceNo != 0) {
        if (redirectTo == "leave-application")
          this.getLeaveApplication()
      }
    })
    this.remarkMaxLength = this.sharedService.getRemarkMaxlength();
  }

  getSettings() {
    this.settingService.getAllSettings().subscribe(response => {
      if (response.isSuccess) {
        let settings = response.responseData;
        if (settings.length > 0) {
          if (this.currentUser.isApprover && !this.isAdmin && settings[0].isLeadersCanApproveApplication) this.isUser = true;
          this.LockApprover = settings[0].isLockApproverSelection;
        }
      } else {
        this._toasterService.showApiValidation(response);
      }
    });
  }

  getleaveabalance() {
    this.leaveBalanceReport = [];
    this._reportService
      .getLeaveBalanceDetails(this._obj)
      .subscribe((response) => {
        if (response.isSuccess) {
          this.leaveBalanceReport = response.responseData;

        }
      });
  }

  getMenuAccess() {
    this.menuAccess = this._navigateRightsService.menuRights(Menus.LEAVE_APPLICATION);
  }
  showdata() {
    this.accessFilter.showEmployeeName = true;
    this.accessFilter.showFromDate = true;
    this.accessFilter.showToDate = true;
    this.accessFilter.showApplicationStatus = true;
    this.accessFilter.showApproverName = true;
    this.accessFilter.showBranch = this.isAdmin ? true : false;
    this.accessFilter.showDepartment = this.isAdmin ? true : false;
    this.accessFilter.showDesignation = this.isAdmin ? true : false;
    this.accessFilter.showLocation = this.isAdmin ? true : false;
    this.accessFilter.showEmployeeCode = this.isAdmin ? true : false;
    this.accessFilter.showEmployeeStatus = this.isAdmin ? true : false;
  }
  getLeaveApplication() {
    this.leaveDataFilter.id = this.sharedService.referenceNo;
    this._leaveApplicationServiceProxy.getAllLeaveApplications(this.leaveDataFilter).subscribe(response => {
      if (response.isSuccess) {
        this.leaveApplications = response.responseData;
        this.sharedService.referenceNo = 0;
        window.dispatchEvent(new Event('resize'));
      } else {
        this._toasterService.showApiValidation(response);
      }
    });
  }
  dateFilter() {
    this.leaveDataFilter.fromDate = this.filterDataService.monthStartDate();
    this.leaveDataFilter.toDate = this.filterDataService.nextMonthLastDate();
    this.filter.fromDate = this.filterDataService.monthStartDate();
    this.filter.toDate = this.filterDataService.nextMonthLastDate();
    this.leaveDataFilter.applicationStatus = this.filterDataService.isAdmin();
    this.filter.applicationStatus = this.filterDataService.isAdmin();
  }

  totalRecord(dataCount: any) {
    dataCount = this.first + dataCount;
    this.allOverTimeArray = this.leaveApplications.slice(this.first, dataCount);
    if (!this.isAdmin)
      this.allOverTimeArray = this.allOverTimeArray.filter(x => x.employee.id != this.currentUser.employeeId && x.leaveStatus == 0)
    const checkData = (this.allOverTimeArray.map(({ id }) => id));
    if (this.allOverTimeStatus) {
      const tempData = this.data.concat(checkData);
      this.data = Array.from(new Set(tempData));
    }
    else this.data = this.data.filter(x => !checkData.includes(x));
    this.selectedValue = this.data;
    if (this.selectedValue.length) this.showButton = true;
    else this.showButton = false;
  }
  approveStatus() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to Approve Selected Leave Application ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedValues.ids = this.selectedValue;
        this.selectedValues.updateTransactionStatus = 1;
        this._leaveApplicationServiceProxy.updateLeaveApplicationStatus(this.selectedValues).subscribe(response => {
          if (response.isSuccess) {
            this.selectedValues.ids = null;
            this.selectedValue = null;
            this.submitDialogs(this.filter);
            this.showButton = false
            this.allOverTimeStatus = false;
            this.showButton = false
            this._toasterService.toastSuccess('Successful', 'Status Change Successfully');
          }
          else {
            this._toasterService.showApiValidation(response);
          }
        });
      }
    });
  }
  rejectStatus() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to Reject Selected Leave Application?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedValues.updateTransactionStatus = 2;
        this.selectedValues.ids = this.selectedValue;
        this._leaveApplicationServiceProxy.updateLeaveApplicationStatus(this.selectedValues).subscribe(response => {
          if (response.isSuccess) {
            this.selectedValues.ids = null;
            this.selectedValue = null;
            this.showButton = false;
            this.allOverTimeStatus = false;
            this.submitDialogs(this.filter);
            this._toasterService.toastSuccess('Successful', 'Status Change Successfully');
          }
          else {
            this._toasterService.showApiValidation(response);
          }
        });
      }
    });
  }

  call() {
    this.allOverTimeStatus = false;
  }
  hideButtons() {
    this.data = this.selectedValue;
    if (this.selectedValue.length > 0) this.showButton = true;
    else this.showButton = false;
  }
  onFilter(data) {
    this.total = data.filteredValue.length;
  }

  getEmployee() {
    this._employeeServiceProxy.getEmployeeWithCode(1, EmployeeType.EMPLOYEE).subscribe(response => {
      if (response.isSuccess) {
        this.employees = response.responseData;
      }
      else this._toasterService.showApiValidation(response);
    });
  }

  getApprover() {
    this._employeeServiceProxy.getAllApprovableEmployees().subscribe(response => {
      if (response.isSuccess) {
        let roleName = this._authenticationService.CurrentUserRoleName();
        this.approversData = response.responseData;
        if (roleName == Roles.USER) {
          let approver = response.responseData;
          this.approvers = approver.filter(x => this.currentUser.employeeId != x.id);
        }
        else this.approvers = response.responseData;
      }
      else this._toasterService.showApiValidation(response);
    });
  }
  getStatus() {
    this._transactionSeriviceProxy.getAllTransactionStatus().subscribe(response => {
      if (response.isSuccess) {
        this.status = response.responseData;
      } else {
        this._toasterService.showApiValidation(response);
      }
    });
  }
  getLeaveType() {
    this._leaveTypeServiceProxy.getActiveLeaveTypes().subscribe(response => {
      if (response.isSuccess) {
        this.leaveTypes = response.responseData;
        if (this.leaveTypes.length > 0) this.isShowBalance = this.leaveTypes[0].isShowBalance;
      } else {
        this._toasterService.showApiValidation(response);
      }
    });
  }
  isSelectedEmployee() {
    let approverId = this.employees.find(y => y.id == this.selectedEmployee).approverId;
    if (approverId) this.selectedApprover = this.approversData.find(x => x.id == approverId)?.id;
    else this.selectedApprover = null;
    this.selectedTimes();
    // this.getSelectedEmployeeShift();
  }

  async getSelectedEmployeeShift(date) {
    return new Promise((resolve, reject) => {
      this._employeeServiceProxy.getEmployee(this.selectedEmployee).subscribe(response => {
        if (response.isSuccess) {
          var employeedata = response.responseData;
          var daysArray = [this.day.Sunday, this.day.Monday, this.day.Thursday, this.day.Wednesday, this.day.Thursday, this.day.Friday, this.day.Saturday];
          var weekdayNum = date.getDay();
          var weekday = daysArray[weekdayNum];
          if (!employeedata.shift)
            this._toasterService.toastWarning("please Contact Admin For your shift timimg");
          let shiftData = employeedata.shift.shiftDay.find(x => x.dayName == weekday);
          if (shiftData) {
            this.shiftInTime = this.datepipe.transform(shiftData.shift.inTime, 'h:mm a');
            this.shiftOutTime = this.datepipe.transform(shiftData.shift.outTime, 'h:mm a');
          }
          resolve(employeedata);
        }
      })
    })

  }
  openNew() {
    this.leaveApplication = new CreateOrUpdateLeaveApplicationDto();
    this.totalDay = null;
    this.submitted = false;
    this.leaveApplicationDialog = true;
    this.selectedEmployee = null;
    this.selectedApprover = null;
    this.selectedLeaveType = null;
    this.editDisable = false;
    this.leaveApplication.leaveStatus = 0;
    this.selectedstatus = 0;
    this.fromTime = this.datepipe.transform(this.date, 'h:mm a');
    this.toTime = this.datepipe.transform(this.date, 'h:mm a');
    this.isShortorHalfLeave = false;
    this.isShowBalance = false;
    this.isBalanceExists = false;
    if (this.employees.length == 1) {
      this.selectedEmployee = this.employees[0].id;
      // this.isSelectedEmployee(this.leaveApplication);
    }
    if(!this.isAdmin && this.LockApprover){
      this.ApproverDisable = true;
      this.isSelectedEmployee();
    }else{
      this.isSelectedEmployee();
    }
  }

  hideDialogs() {
    this.leaveApplicationDialog = false;
    this.submitted = false;
  }


  async saveLeaveApplication() {
    this.isBalanceExists = false;
    // if (!this.LeaveValidation()) {
    //   this.isBalanceExists = true;
    //   return;
    // }
    if (this.leaveApplication.fromDateTime) {
      await this.getSelectedEmployeeShift(this.leaveApplication.fromDateTime);
    }

    this.dayCalculation();
    let input = new CreateOrUpdateLeaveApplicationDto();
    this.submitted = true;
    this.leaveSubmit = this.filterDataService.isAdmin();
    input.id = this.leaveApplication.id ? this.leaveApplication.id : 0;
    this.leaveApplication.leaveReason = this.leaveApplication.leaveReason.trim();
    input.leaveReason = this.leaveApplication.leaveReason;
    input.leaveStatus = this.isAdmin ? this.selectedstatus : 0;
    input.employeeId = this.selectedEmployee;
    input.approverId = this.selectedApprover;
    input.leaveTypeId = this.selectedLeaveType;
    this.balance = this.balance;
    this.leaveSubmit = true;
    let shiftFromTime = this.sharedService.getngxTimerTime(this.shiftInTime, this.leaveApplication.fromDateTime);
    let shiftToTime = this.sharedService.getngxTimerTime(this.shiftOutTime, this.leaveApplication.toDateTime);
    let fromDateTime = this.sharedService.getngxTimerTime(this.fromTime, this.leaveApplication.fromDateTime);
    let toDateTime = this.sharedService.getngxTimerTime(this.toTime, this.leaveApplication.fromDateTime);
    if (input.leaveReason.length < this.remarkMaxLength) {
      return false;
    }
    if (!(this.leavetypename == "Short Leave" || this.leavetypename == "Half Leave")) {
      this.leaveApplication.fromDateTime = shiftFromTime;
      this.leaveApplication.toDateTime = shiftToTime;
    }
    else {
      if (this.minimumTime && this.isValidTime && this.leaveApplication.fromDateTime) {
        this.leaveApplication.fromDateTime = fromDateTime
        this.leaveApplication.toDateTime = toDateTime
      }
      else {
        return false
      }
    }
    input.fromDateTime = this.sharedService.getlocalDatetime(this.leaveApplication.fromDateTime);
    input.toDateTime = this.sharedService.getlocalDatetime(this.leaveApplication.toDateTime);
    if ((toDateTime < shiftFromTime || fromDateTime > shiftToTime) && (this.leavetypename == "Short Leave" || this.leavetypename == "Half Leave")) {
      this.confirmationService.confirm({
        message: `Your shift time is from ${this.shiftInTime} to ${this.shiftOutTime} <br/> and you have selected ${this.fromTime} to ${this.toTime}. <br/> Do you want to continue ?`,
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {

          this.saveLeave(input);
        }
      });
    }
    else {
      this.saveLeave(input);
    }
  }
  editLeaveApplication(leaveApplication: LeaveApplicationDto) {
    let val = this.employees.find(x => x.id == leaveApplication.employee.id);
    this.leaveApplication = new CreateOrUpdateLeaveApplicationDto();
    if (!val) {
      this.employee = new EmpNameWithCode();
      this.employee.id = leaveApplication.employee.id;
      this.employee.employeeName = leaveApplication.employee.displayName;
      this.employees.push(this.employee);
    }
    let fromDateTime: any = new Date(leaveApplication.fromDateTime);
    let toDateTime: any = new Date(leaveApplication.toDateTime);
    let diff = Math.abs(fromDateTime.getTime() - toDateTime.getTime());
    this.originalDiffDay = Math.ceil(diff / (1000 * 3600 * 24));
    this.originalDiffDay = this.originalDiffDay + this.balance;
    this.leaveApplication = JSON.parse(JSON.stringify(leaveApplication));
    this.leaveApplication.fromDateTime = leaveApplication.fromDateTime;
    this.leaveApplication.toDateTime = leaveApplication.toDateTime;
    this.selectedEmployee = leaveApplication.employee.id;
    this.selectedApprover = leaveApplication.approver.id;
    this.fromTime = this.datepipe.transform(leaveApplication.fromDateTime, 'h:mm a');
    this.toTime = this.datepipe.transform(leaveApplication.toDateTime, 'h:mm a');
    this.shiftInTime = this.datepipe.transform(leaveApplication.fromDateTime, 'h:mm a');
    this.shiftOutTime = this.datepipe.transform(leaveApplication.toDateTime, 'h:mm a');
    this.selectedLeaveType = leaveApplication.leaveType.id;
    this.selectedstatus = leaveApplication.leaveStatus;
    this.rolewiseData = this.filterDataService.isAdmin();
    this.leaveApplicationDialog = true;
    this.editDisable = true;
    this.isBalanceExists = false;
    this.leavetypename = this.selectedLeaveType ? this.leaveTypes.find(x => x.id == leaveApplication.leaveType.id).leaveName : '';
    if (this.leavetypename == "Short Leave" || this.leavetypename == "Half Leave") {
      this.isShortorHalfLeave = true;
    }
    this.submitted = true;
    this.dayCalculation();
    this.getleaveabalance();
  }

  onHide() {
    if (this.employee) {
      this.employees = this.employees.filter(x => x.id != this.employee.id);
      this.employee = null;
    }
  }

  deleteLeaveApplication(leaveApplication: LeaveApplicationDto) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${leaveApplication.employee.empName}'s Leave ?`,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        this._leaveApplicationServiceProxy.deleteLeaveApplication(leaveApplication.id).subscribe(response => {
          if (response.isSuccess) {
            this.leaveApplication = new CreateOrUpdateLeaveApplicationDto();
            this.leaveApplications = this.leaveApplications.filter(x => x.id !== leaveApplication.id);
            this._toasterService.toastSuccess('Successful', 'Leave Application Deleted');
            this.getleaveabalance();
          }
          else {
            this._toasterService.showApiValidation(response);
          }
        })
      }
    });
  }
  dayCalculation() {
    if (this.leaveApplication.fromDateTime && this.leaveApplication.toDateTime) {
      var startdateMoment = this.sharedService.getngxTimerTime(this.fromTime, this.leaveApplication.fromDateTime)
      var enddateMoment = this.sharedService.getngxTimerTime(this.toTime, this.leaveApplication.toDateTime);
      this.totalDay = this.timeDiffCalc(startdateMoment, enddateMoment);
      this.selectedTimes();
    }
  }
  setDateValue() {
    this.leaveApplication.toDateTime = this.leaveApplication.fromDateTime;
    this.dayCalculation()
  }
  setFromTimeFromTimePicker($event) {
    this.fromTime = $event;
    this.dayCalculation();
  }
  setToTimeFromTimePicker($event) {
    this.toTime = $event;
    this.dayCalculation();
  }
  
  selectedTimes() {
    let leaveTypeObj = this.selectedLeaveType ? this.leaveTypes.find(x => x.id == this.selectedLeaveType) : new LeaveDto();
    this.isBalanceExists = false
    if (leaveTypeObj) {
      this.leavetypename = leaveTypeObj.leaveName;
      this.isShowBalance = leaveTypeObj.isShowBalance;
      this.balance = this.selectedEmployee ? this.leaveBalanceReport.find(x => x.employee.id == this.selectedEmployee && x.leaveTypeId == this.selectedLeaveType)?.balanceLeave : 0;
      if (this.balance === null || this.balance === undefined)
        this.balance = leaveTypeObj.leaveName == "Short Leave" ? leaveTypeObj.leaveMaxMinutes : leaveTypeObj.monthlyEarn;
    }

    if (this.leavetypename == "Short Leave" || this.leavetypename == "Half Leave") {
      this.leaveApplication.toDateTime = this.leaveApplication.fromDateTime;
      this.isLeaveDisabled = true;
      this.isShortorHalfLeave = true;

      this.selectedTime = this.leaveTypes.find(x => x.id == this.selectedLeaveType);
      this.time = this.selectedTime.leaveMaxMinutes;
      this.leavetype = this.selectedTime.leaveName;
      if (this.maximum > this.time) {
        this.isValidTime = false;
        return;
      }
      else this.isValidTime = true;
    }
    else {
      this.isShortorHalfLeave = false;
      this.isLeaveDisabled = false;
    }
    if (this.balance <= 0) {
      this.isBalanceExists = false
    }
  }

  timeDiffCalc(dateFuture, dateNow) {
    if (dateNow > dateFuture) {
      let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
      // calculate days
      const days = Math.floor(diffInMilliSeconds / 86400);
      diffInMilliSeconds -= days * 86400;
      // calculate hours
      const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
      diffInMilliSeconds -= hours * 3600;
      // calculate minutes
      const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
      diffInMilliSeconds -= minutes * 60;
      if (days === 0 && hours === 0 && minutes < 15) {
        this.minimumTime = false;
      }
      else this.minimumTime = true;
      if (days || hours || minutes) {
        let day = days * 24;
        let minute = ((day + hours) * 60);
        this.maximum = minute + minutes;
      }
      let difference = '';
      difference += (days === 0 || days === 1) ? `${days} days` : `${days} days `;
      difference += (hours === 0 || hours === 1) ? ` ${hours} hours ` : ` ${hours} hours `;
      difference += (minutes === 0 || hours === 1) ? ` ${minutes} minutes` : ` ${minutes} minutes`;
      return difference;
    }
    else {
      this.minimumTime = false;
    }
  }

  openFilter() {
    this.filterDialog = true;
  }
  hideDialog(state): void {
    this.filterDialog = state;
  }
  resetDialog(state) {
    this.filter.fromDate = this.filterDataService.monthStartDate()
    this.filter.toDate = this.filterDataService.nextMonthLastDate();
    this.filter.applicationStatus = this.filterDataService.isAdmin();
    this.filter.employeeStatus = -1;
  }
  submitDialogs(leaveDataFilter: TransactionApplicationDto) {
    this.rolewiseData = this.filterDataService.isAdmin();
    let _obj = new TransactionApplicationDto();
    _obj.employeeIds = leaveDataFilter.employeeIds;
    _obj.fromDate = this.sharedService.getlocalDatetime(leaveDataFilter.fromDate)
    _obj.toDate = this.sharedService.getlocalDatetime(leaveDataFilter.toDate)
    _obj.applicationStatus = leaveDataFilter.applicationStatus;
    _obj.approverIds = leaveDataFilter.approverIds;
    _obj.branchIds = leaveDataFilter.branchIds;
    _obj.locationIds = leaveDataFilter.locationIds;
    _obj.designationIds = leaveDataFilter.designationIds;
    _obj.departmentIds = leaveDataFilter.departmentIds;
    _obj.employeeCode = leaveDataFilter.employeeCode;
    _obj.employeeStatus = leaveDataFilter.employeeStatus;

    this._leaveApplicationServiceProxy.getAllLeaveApplications(_obj).subscribe(response => {
      if (response.isSuccess) {
        this.leaveApplications = response.responseData;
        this.total = this.leaveApplications.length;
        this.filterDialog = false;
        this.changeDetector.detectChanges();
        // this.getLeaveApplication();
      }
      else this._toasterService.showApiValidation(response);
    });
  }

  LeaveValidation() {
    let isPaidLeave = false;
    let balanceLeave = 0;
    let leaveTypeObj = this.selectedLeaveType ? this.leaveTypes.find(x => x.id == this.selectedLeaveType) : new LeaveDto();
    if (leaveTypeObj) {
      isPaidLeave = leaveTypeObj.isPaid;
      const existingBalance = this.leaveApplication.id ? this.originalDiffDay : 0;
      balanceLeave = this.selectedEmployee ? this.leaveBalanceReport.find(x => x.employee.id == this.selectedEmployee && x.leaveTypeId == this.selectedLeaveType)?.balanceLeave : 0;
      balanceLeave += existingBalance;
    }
    if (isPaidLeave) {
      balanceLeave = balanceLeave ?? 0;
      let fromDateTime: any = new Date(this.leaveApplication.fromDateTime.toDateString());
      let toDateTime: any = new Date(this.leaveApplication.toDateTime.toDateString());
      let dateDiff = toDateTime - fromDateTime;
      this.dayDiff = (dateDiff / 1000 / 3600 / 24) + 1;

      if (this.dayDiff > balanceLeave) {
        return false;
      }
    }
    return true;

  }

  ExportExcel() {
    this.exportList = [];
    this.exportList = this.leaveApplications.map(x => {
      return {
        "Employee": x.employee.displayName,
        "Request Date": this.datepipe.transform(x.leaveRequestDate, this.dateFormat),
        "Leave Type": x.leaveType.leaveName,
        "From Date": this.datepipe.transform(x.fromDateTime, this.dateTimeformat),
        "To Date": this.datepipe.transform(x.toDateTime, this.dateTimeformat),
        "Reason": x.leaveReason,
        "Approver": x.approver?.displayName,
        "Status": x.leaveStatus == 0 ? 'Pending' : x.leaveStatus == 1 ? 'Approved' : 'Rejected',
      }
    }) as any;
    this._exportDataService.exportExcel(this.exportList, "Leave Application");
  }
  saveLeave(input: CreateOrUpdateLeaveApplicationDto) {
    // if (this.isValidTime) {
    this._leaveApplicationServiceProxy.createOrUpdateLeaveApplication(input).subscribe(response => {
      if (response.isSuccess) {
        this.selectedApprover = 0;
        this.selectedstatus = 0;
        this.leaveApplication.id ? this._toasterService.toastSuccess('Successful', 'Leave Application Updated') : this._toasterService.toastSuccess('Successful', 'Leave Application Save Successfully');
        this.leaveApplication = new CreateOrUpdateLeaveApplicationDto
        this.leaveApplicationDialog = false;
        this.submitDialogs(this.filter);
        this.getleaveabalance();
      }
      else this._toasterService.showApiValidation(response);
    });
    // }
  }
}

